import { Outlet } from "react-router";

export default function App() {
  return (
    <>
      <Outlet />
    </>
  );
}
